import { render, staticRenderFns } from "./CloseOrder.vue?vue&type=template&id=27fa0744"
import script from "./CloseOrder.vue?vue&type=script&lang=js"
export * from "./CloseOrder.vue?vue&type=script&lang=js"
import style0 from "./CloseOrder.vue?vue&type=style&index=0&id=27fa0744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports